import Loading from '@@/core/components/shared/Loading/Loading'
import mixins from '@@/core/mixins/mixins'
import FormModal from "@@/core/libraries/form/FormModal";
import {BButton, BCard, BCollapse, BFormGroup, BFormInput, BTable, BTooltip, VBToggle} from "bootstrap-vue";

export default {
  name: "Story",
  components: {
    FormModal,
    Loading,
    BTooltip, BButton, BCollapse, BCard, BFormGroup, BFormInput, BTable
  },
  directives: {
    'b-toggle': VBToggle,
  },
  mixins: [mixins],
  data() {
    return {
      url: 'admin/stories',
      fields: [{
        key: 'id',
        label: 'شناسه'
      },
        {
          key: 'title',
          label: 'عنوان'
        },
      
        {
          key: 'status',
          label: 'وضعیت'
        },
        {
          key: 'created_at',
          label: 'تاریخ ثبت'
        },
        {
          key: 'edit',
          label: 'ویرایش'
        },
        {
          key: 'delete',
          label: 'حذف'
        },
      ],
      status_options: [{
        name: 'فعال',
        value: '1'
      },
        {
          name: 'غیرفعال',
          value: '0'
        },
        {
          name: 'همه',
          value: ''
        },
      ],
    }
  },
  mounted() {
    this.loadItems()
  },
  watch: {
   
  },
  methods: {
  }
}
